/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProfilePrivacyPreference
 */
export interface ProfilePrivacyPreference {
    /**
     * 
     * @type {boolean}
     * @memberof ProfilePrivacyPreference
     */
    profileVisible: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProfilePrivacyPreference
     */
    profileSearchable: boolean;
}

/**
 * Check if a given object implements the ProfilePrivacyPreference interface.
 */
export function instanceOfProfilePrivacyPreference(value: object): value is ProfilePrivacyPreference {
    if (!('profileVisible' in value) || value['profileVisible'] === undefined) return false;
    if (!('profileSearchable' in value) || value['profileSearchable'] === undefined) return false;
    return true;
}

export function ProfilePrivacyPreferenceFromJSON(json: any): ProfilePrivacyPreference {
    return ProfilePrivacyPreferenceFromJSONTyped(json, false);
}

export function ProfilePrivacyPreferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfilePrivacyPreference {
    if (json == null) {
        return json;
    }
    return {
        
        'profileVisible': json['profileVisible'],
        'profileSearchable': json['profileSearchable'],
    };
}

export function ProfilePrivacyPreferenceToJSON(value?: ProfilePrivacyPreference | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'profileVisible': value['profileVisible'],
        'profileSearchable': value['profileSearchable'],
    };
}

